export * from './types';
export * from './slide';
export * from './leaderboard';
export * from './resource';
export * from './livestream';
export * from './promotion';
export * from './message';
export * from './user';

import axios, { type AxiosInstance } from 'axios';
import {
  ApiLivestreamEndpoint,
  ApiMessageEndpoint,
  ApiPromotionEndpoint,
  ApiResourceEndpoint,
  ApiUserEndpoint,
  AuthService
} from '@/services';
import type { IAuthData } from '@/services';
import { ApiSlideEndpoint } from '@/services';
import { ApiLeaderboardEndpoint } from '@/services';

export class ApiService {
  axios: AxiosInstance;
  slide: ApiSlideEndpoint;
  leaderboard: ApiLeaderboardEndpoint;
  resource: ApiResourceEndpoint;
  livestream: ApiLivestreamEndpoint;
  promotion: ApiPromotionEndpoint;
  message: ApiMessageEndpoint;
  user: ApiUserEndpoint;

  constructor(authService: AuthService) {
    this.axios = axios.create({
      baseURL: `${authService.config.NV_GATEWAY}`
    });

    this.slide = new ApiSlideEndpoint(this.axios);
    this.leaderboard = new ApiLeaderboardEndpoint(this.axios);
    this.resource = new ApiResourceEndpoint(this.axios);
    this.livestream = new ApiLivestreamEndpoint(this.axios);
    this.promotion = new ApiPromotionEndpoint(this.axios, authService.config);
    this.message = new ApiMessageEndpoint(this.axios);
    this.user = new ApiUserEndpoint(this.axios);
  }

  async init(auth: IAuthData) {
    this.axios.defaults.headers.Authorization = 'oauth ' + auth.access_token;
  }
}
